import { createFileRoute } from '@tanstack/react-router';
import { TransfersPage } from '@/features/inventory/TransfersPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/transfers')({
  component: TransfersPage,
});
